import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import Grid from '@material-ui/core/Grid/Grid';
import Icon from '@material-ui/core/Icon';
import { useAlert, types } from 'react-alert';
import { PageTitle, SecondaryButton, PaperWithTitle, PagingTable, ConfirmDialog } from '../../../components';
import { useClinicUser, useJobOffer, useMaster } from '../../../../model/hooks';
import { getLabelFromString, getNumber, getLabelFromTimestamp, getLabelWorkingDate, getLabelRecruitment, getLabelEmployment, getLabelReward, isJobOfferBadge, isUnregisteredUser, } from '../../../common/helper';
import { Utils } from '../../../../common/helper';
import { getLabelWorkingTime } from '../../../common/helper/FormHelper';
export const JobOffer = () => {
    const { t } = useTranslation();
    const reactAlert = useAlert();
    const { master } = useMaster();
    const history = useHistory();
    const { jobClinic, paymentClinic } = useClinicUser();
    const { columns, loading, loadJobOfferList } = useJobOffer();
    const [rows, setRows] = useState([]);
    const [isOpenDialog, setIsOpenDialog] = useState(false);
    const loadData = async (lastDocument) => {
        const result = await loadJobOfferList(lastDocument);
        return result.data.map((item) => {
            return {
                id: item.id,
                content: getLabelFromString(item.title),
                date: getLabelWorkingDate(item.employmentId, item.startWorkingTime, item.endWorkingTime),
                time: getLabelWorkingTime(item.employmentId, item.startWorkingTime, item.endWorkingTime),
                reward: getLabelReward(master.rewardTypeList, item.rewardTypeId, item.rewardAmount),
                type: getLabelEmployment(master.employmentList, item.employmentId),
                count: getNumber(item.jobAppliedCount),
                deadline: getLabelFromTimestamp(item.offerDeadline, false),
                status: getLabelRecruitment(t, item.isRecruitment),
                notificationFlag: isJobOfferBadge(item),
                detail: item,
            };
        });
    };
    const onMore = async () => {
        if (rows.length > 0) {
            const lastRow = rows.slice(-1)[0];
            const _rows = await loadData(lastRow.detail.snapshot);
            if (_rows.length > 0) {
                setRows(rows.concat(_rows));
            }
        }
    };
    useEffect(() => {
        const f = async () => {
            try {
                const _rows = await loadData();
                setRows(_rows);
            }
            catch (e) {
                if (e instanceof Error) {
                    reactAlert.show(e.message, { type: types.ERROR });
                }
            }
        };
        if (Utils.isNotNull(jobClinic) && Utils.isNotNull(master)) {
            f();
        }
    }, [jobClinic, master]);
    const onClickNew = () => {
        if (isUnregisteredUser(paymentClinic)) {
            setIsOpenDialog(true);
        }
        else {
            history.push('/home/job_offer/edit_contents');
        }
    };
    const onClickContent = (id) => {
        var _a;
        const jobOffer = rows.find((item) => item.id === id);
        const jobOfferParam = { ...(_a = jobOffer) === null || _a === void 0 ? void 0 : _a.detail.data() };
        history.push(`/home/job_offer/detail/${id}`, { jobOffer: jobOfferParam });
    };
    const onClickCopyCreate = (id) => {
        var _a;
        const jobOffer = rows.find((item) => item.id === id);
        const jobOfferParam = { ...(_a = jobOffer) === null || _a === void 0 ? void 0 : _a.detail.data() };
        history.push(`/home/job_offer/edit_contents`, { jobOffer: jobOfferParam });
    };
    const onCloseDialog = () => setIsOpenDialog(false);
    const onClickPositive = () => history.push('/home/account');
    return (React.createElement(React.Fragment, null,
        React.createElement(PageTitle, null, t('求人管理')),
        React.createElement(SGrid, { container: true },
            React.createElement(Grid, { item: true, xs: 12, sm: 3 },
                React.createElement(SButtonArea, null,
                    React.createElement(SecondaryButton, { fullWidth: true, size: "large", disabled: !paymentClinic, onClick: onClickNew },
                        React.createElement(SLabelContainer, null,
                            React.createElement(SIcon, null, "add_box"),
                            "\u65B0\u898F\u4F5C\u6210")))),
            React.createElement(Grid, { item: true, xs: 12 },
                React.createElement(PaperWithTitle, { title: "\u52DF\u96C6\u4E00\u89A7" },
                    React.createElement(PagingTable, { columns: columns, rows: rows, loading: loading, onClickContent: onClickContent, onClickExpandMore: onMore, onClickCopyCreate: onClickCopyCreate })))),
        React.createElement(ConfirmDialog, { isOpen: isOpenDialog, title: "", negativeLabel: t('戻る'), positiveLabel: t('登録へ進む'), onClose: onCloseDialog, onClickNegative: onCloseDialog, onClickPositive: onClickPositive, loading: loading, isCancel: true },
            React.createElement(SConfirmMessage, null, t(`先に「アカウント情報」からクレジットカード${'\n'}を登録してご契約プランを選択しましょう。`)))));
};
const SGrid = styled(Grid) `
  padding-bottom: 32px;
`;
const SButtonArea = styled.div `
  padding-top: 32px;
  padding-bottom: 32px;
`;
const SLabelContainer = styled.span `
  display: flex;
  align-items: center;
  padding-top: 8px;
  padding-bottom: 8px;
`;
const SIcon = styled(Icon) `
  margin-right: 8px;
`;
const SConfirmMessage = styled.p `
  font-weight: bold;
  text-align: center;
  margin-top: 32px;
  margin-bottom: 16px;
  white-space: pre-wrap;
`;
